import { SearchFilterV2StoreContext } from '@repo/common/components/Filter/store';
import { createContext, useContext } from 'react';
import type LineageFlowStore from '../../store/LineageFlowStore';
import type LineageFlowUIStore from '../../store/LineageFlowUIStore';

export const LineageFlowContext = createContext<LineageFlowStore | null>(null);
export const LineageFlowUIContext = createContext<LineageFlowUIStore | null>(
	null
);

export const useLineageFlowContext = () => {
	const store = useContext(LineageFlowContext);
	if (!store) {
		throw new Error(
			'useLineageFlowContext must be used within a LineageFlowProvider'
		);
	}
	return store;
};

export const useLineageFlowUIContext = () => {
	const store = useContext(LineageFlowUIContext);
	if (!store) {
		throw new Error(
			'useLineageFlowUIContext must be used within a LineageFlowProvider'
		);
	}
	return store;
};

export const useLineageFlowFilterContext = () => {
	const store = useContext(SearchFilterV2StoreContext);
	if (!store) {
		throw new Error(
			'useLineageFilterContext must be used within a LineageFlowProvider'
		);
	}
	return store;
};
